import React from 'react'
import Spinner from './Spinner'
import { Link } from 'react-router-dom'
import { type To } from 'react-router'

interface Props {
  className?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  children?: React.ReactNode
  href?: string
  disabled?: boolean
  contrast?: boolean
  outlined?: boolean
  text?: boolean
  small?: boolean
  loading?: boolean
  to?: To
  onClick?: React.MouseEventHandler<HTMLButtonElement> &
    React.MouseEventHandler<HTMLAnchorElement>
  style?: React.CSSProperties
  target?: string
  rel?: string
}

function Btn(props: Props): React.ReactElement {
  const Tag = props.href ? 'a' : 'button'
  const type = props.href ? undefined : props.type ?? 'button'

  const modifiers = React.useMemo((): string => {
    const LIST = ['disabled', 'contrast', 'outlined', 'text', 'small']

    return LIST.reduce((acc: string[], item: string) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (props[item]) {
        acc.push(`_${item}`)
      }

      return acc
    }, []).join(' ')
  }, [props])

  if (!props.to) {
    return (
      <Tag
        className={`btn ${modifiers} ${props.className ?? ''}`.trim()}
        type={type}
        onClick={props.onClick}
        style={props.style}
        target={props.target}
        href={props.href || undefined}
        rel={props.rel}
      >
        <span
          className={`btn__inner ${
            props.loading ? 'visibility-hidden' : ''
          }`.trim()}
        >
          {props.children}
        </span>
        <Spinner style={{ display: !props.loading && 'none' }}></Spinner>
      </Tag>
    )
  } else {
    return (
      <Link
        className={`btn ${modifiers} ${props.className ?? ''}`.trim()}
        to={props.to}
        onClick={props.onClick}
        style={props.style}
      >
        <span
          className={`btn__inner ${
            props.loading ? 'visibility-hidden' : ''
          }`.trim()}
        >
          {props.children}
        </span>
        <Spinner style={{ display: !props.loading && 'none' }}></Spinner>
      </Link>
    )
  }
}

export default Btn
